import React from "react";

function Twitter() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
    >
      <g
        id="Group_27760"
        data-name="Group 27760"
        transform="translate(-2905 24292)"
      >
        <circle
          id="Background"
          cx="28"
          cy="28"
          r="28"
          transform="translate(2905 -24292)"
        />
        <path
          id="Path_18538"
          data-name="Path 18538"
          d="M29.247,11.679,39.294,0H36.913L28.189,10.141,21.222,0H13.185L23.722,15.335,13.185,27.582h2.381l9.213-10.709,7.359,10.709h8.037l-10.927-15.9ZM25.986,15.47l-1.068-1.527L16.424,1.792h3.657L26.936,11.6,28,13.125l8.911,12.746H33.257l-7.272-10.4Z"
          transform="translate(2906.815 -24278)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default Twitter;
